module.exports = __webpack_public_path__ + "static/media/fb-logo-white.e3d3a393.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fb-logo-white.svg
// module id = 467
// module chunks = 0